module.exports = __webpack_public_path__ + "static/media/verified.38fad941.png";